import React, { useState }from 'react';
import { tributeData } from '../data';
import { PhotoAlbum } from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

const slides = tributeData.images.map(({
  original, width, height})=>({
    src: original,
    width,
    height,
  }));

const GallerySection = () => {
  const [index, setIndex] = useState(-1);
  const {title,subtitle, images} = tributeData;

  return (
    <section className='bg-[#f9f9f9] section relative mt-[10px] lg:mt-0 lg:py-10 xl:pb-20'>
      <div className='container mx-auto'>
        <motion.h2 
          variants={fadeIn('up')}
          initial='hidden'
          whileInView={'show'}
          viewport={{once:false, amount: 0.6}}
          className='h2 xl:text-[40px] max-w-[380px] lg:mb-15'>{title}
        </motion.h2>
      </div>
      {/* subtitle content  */}
      <motion.div 
        variants={fadeIn('up')}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false, amount: 0.2}}
        className='flex'>
        <div className="mt-0 p-[25px] max-w-full text-grey">
          <p className="mb-6">{subtitle}</p>
        </div>
      </motion.div>

      <motion.div 
        variants={fadeIn('up')}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false, amount: 0.2}}
        className='mb-8 lg:mb-20'>
        <PhotoAlbum 
          onClick={(event, photo, index)=> setIndex(index)} 
          layout='rows' 
          photos={images}
        />
        <Lightbox
          slides={slides}
          styles={{container:{ backgroundColor:'rgba(0,0,0,.9)'}}}
          open={index>=0}
          index={index}
          close={()=> setIndex(-1)}
        />
      </motion.div>
      {/* <motion.div 
        variants={fadeIn('up')}
        initial='hidden'
        whileInView={'show'}
        viewport={{once:false, amount: 0.2}}
        className='flex justify-center'>
        <button className='btn btn-lg btn-dark lg:mt-[-35px]'>
          {btnText}<div className='text-xl'>{btnIcon}</div>
        </button>
      </motion.div> */}
    </section>

  );
};

export default GallerySection;